import { atom, useAtom, type Atom, } from "jotai";

export declare type Selectable<T extends object = object> = { value: string; label: string; sid: string; item?: T; }
export declare type SelectionAtomState = { open: boolean; values: Selectable[]; selected: Selectable | null; width: number; height: number; }

export const selections:Record<string, Atom<SelectionAtomState>> = {}


export const useSelections = ( key: string ): [ SelectionAtomState, (state: SelectionAtomState) => void] => {

	let selection: SelectionAtomState = { open: false, values: [], selected: null, width: -1, height: -1, };
	let setSelection: (state: SelectionAtomState) => void = () => {};

	const [ atom, setAtom ] = useAtom(selections[key], { "delay": 100 });

	const interval = setInterval(() => {
		if( key in selections) {
			clearInterval(interval);
			selection = atom;
			setSelection = setAtom;
		}
	}, 10);

	return [ selection, setSelection ];
}
